import { useState } from 'react'

import { IconKey } from '@swaggerhub-portal/component-library'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { RequestAccessModal } from '~/components/ConsumerRequestAccessModal'
import { LandingProduct } from '~/types/product.ts'

export interface RequestAccessButtonProps {
  accentColor?: string;
  isPending: boolean;
  product: LandingProduct;
  userFullName?: string;
}

export const RequestAccessButton = ({
  accentColor,
  isPending = false,
  product,
  userFullName,
}: RequestAccessButtonProps) => {
  const { t } = useTranslation()

  const [modalOpen, setModalOpen] = useState(false)

  const handleClick = () => {
    setModalOpen(true)
  }

  return (
    <>
      <button
        aria-label={t('portal.landingPage.productTile.requestAccess.button.ariaLabel')}
        disabled={isPending}
        onClick={handleClick}
        className={clsx(
          'h-8 w-8 border-1.5 flex items-center bg-transparent rounded pointer-events-auto font-semibold justify-center px-2 gap-2',
          'disabled:text-neutral-50 disabled:bg-neutral-15 disabled:border-neutral-40',
          'dark:text-neutral-20 dark:disabled:text-neutral-50 dark:disabled:bg-neutral-90 dark:disabled:border-neutral-80',
          !accentColor && '!border-accent-60',
          !isPending && ' hover:!bg-neutral-95 hover:!border-neutral-95 hover:!text-neutral-00',
          !isPending && 'dark:hover:!bg-neutral-30 dark:hover:!border-neutral-30 dark:hover:!text-neutral-95'
        )}
        style={{ fontSize: '10px', lineHeight: '11px', borderColor: !isPending ? accentColor : undefined }}
      >
        <IconKey width={16} height={16} />
      </button>
      <RequestAccessModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        product={product}
        userFullName={userFullName || ''}
        accentColor={accentColor}
      />
    </>
  )
}